import { getInstallmentDetails, getPixData, getSummary, getWebhookNotificationDetailsData, getWebhookNotificationsData, PaymentPlanActionTypes, setInstallments, setLoading, setLoadingDisablePlan, setLoadingGeneratePaymentMethod, setLoadingInstallmentDetails, setLoadingPix, setLoadingSummary, setPlan, setPlans } from "store/reducers/paymentPlan.reducer";
import handleError from "utils/handleError";
import { getPaymentPlanInstallments, getPaymentsPlan, getPaymentsPlanRead, deleteDisableBoleto, getPaymentPlanInstallmentDetails, postPaymentMethod, getPixStatus, getWebhookNotifications, getWebhookNotificationsDetails, getSummaryPaymentPlan } from "utils/web-api";
import Notification from 'utils/notifications';
import { toast } from "react-toastify";

const { takeEvery, all, call, put, delay, select, debounce, takeLatest } = require("redux-saga/effects");

function* asyncPaymentPlans({payload}) {
    const {page, pageSize, status, search, sort, orderBy} = payload;
    try {
      yield put(setLoading(true));
      const token = yield select(state => state.Auth.token);
      const response = yield call(() => getPaymentsPlan(token, page, pageSize, status, search, sort, orderBy));
      yield put(setPlans(response));
    } catch (error) {
      handleError(error);
    } finally {
      yield put(setLoading(false));
    }
  }

  function* asyncPaymentPlan({id}) {
    try {
      yield put(setLoading(true));
      const token = yield select(state => state.Auth.token);
      const response = yield call(() => getPaymentsPlanRead(id, token));
      const responseInstallments = yield call(() => getPaymentPlanInstallments(id, token));
      yield put(setInstallments(responseInstallments));
      yield put(setPlan(response));
    } catch (error) {
      handleError(error);
    } finally {
      yield put(setLoading(false));
    }
  }

  function* asyncGeneratePaymentMethod(payload) {
    const {id, num, data, onClose, expandedId} = payload.payload;
    try {
      yield put(setLoadingGeneratePaymentMethod(true));
      const token = yield select(state => state.Auth.token);
      yield call(() => postPaymentMethod(id, num, data, token))

      const responseInstallments = yield call(() => getPaymentPlanInstallments(id, token));
      yield put(setInstallments(responseInstallments));

      if (expandedId) {
        const responseInstallmentDetails = yield call(() => getPaymentPlanInstallmentDetails(id, num, token));
        yield put(getInstallmentDetails(responseInstallmentDetails));
      }

      if(data.method === 'boleto') {
        toast.success('Boleto gerado com sucesso');
      } else {
          toast.success('Pix gerado com sucesso');
      }

      yield call(onClose);
    } catch (error) {
      if(error?.response?.status !== 401) {
        Notification('error', `${error.response.data.detail}`);
      } else {
        handleError();
      }
    } finally {
      yield put(setLoadingGeneratePaymentMethod(false));
    }
  }

  function* asyncDisablePlan(payload) {
    const {id} = payload.payload;
    try {
      yield put(setLoadingDisablePlan(true));
      const token = yield select(state => state.Auth.token);
      yield call(() => deleteDisableBoleto(id, token))
      Notification('success', 'Plano desabilitado com sucesso!');
      yield delay(2000);
      window.location.reload(true);
    } catch (error) {
      handleError(error);
      Notification('error', `${error.response.data.detail}`);
    } finally {
      yield put(setLoadingDisablePlan(true));
    }
  }

  function* asyncInstallmentDetails(payload) {
    const {id, num} = payload.payload;
    try {
      yield put(setLoadingInstallmentDetails(true));
      const token = yield select(state => state.Auth.token);
      const response = yield call(() => getPaymentPlanInstallmentDetails(id, num, token));
      yield put(getInstallmentDetails(response));
    } catch (error) {
      handleError();
    } finally {
      yield put(setLoadingInstallmentDetails(false));
    }
  }

  function* asyncPix(payload) {
    const {id, isLoading} = payload.payload;

    try {
      if(isLoading) {
        yield put(setLoadingPix(true));
      }
      const response = yield call(() => getPixStatus(id));
      yield put(getPixData(response));
    } catch (error) {
      if(error?.response?.status === 404) {
        yield put(getPixData({error: true}));
      } else {
        handleError();
      }
    } finally {
      yield put(setLoadingPix(false));
    }
  }

  function* asyncWebhooks(payload) {
      const {page, pageSize, search} = payload.payload;

      try {
        yield put(setLoading(true));
        const token = yield select(state => state.Auth.token);
        const response = yield call(() => getWebhookNotifications(token, page, pageSize, search));
        yield put(getWebhookNotificationsData(response));
      } catch (error) {
        handleError();
      } finally {
      yield put(setLoading(false));
      }
  }

  function* asyncWebhooktDetails(payload) {
    const {id} = payload.payload;

    try {
      yield put(setLoading(true));
      const token = yield select(state => state.Auth.token);
      const response = yield call(() => getWebhookNotificationsDetails(token, id));
      yield put(getWebhookNotificationDetailsData(response));
    } catch (error) {
      handleError();
    } finally {
      yield put(setLoading(false));
    }
  }

  function* asyncSummary({payload}) {
    try {
      yield put(setLoadingSummary(true))
      const token = yield select(state => state.Auth.token);
      const response = yield call(() => getSummaryPaymentPlan(token, payload));
      yield put(getSummary(response));
    } catch (error) {
     Notification('error', 'Erro ao carregar total de planos.');
    } finally {
      yield put(setLoadingSummary(false));
    }
  }

  export default function* MySaga() {
    yield all([
      yield debounce(500, PaymentPlanActionTypes.ASYNC_PAYMENT_PLANS, asyncPaymentPlans),
      yield takeEvery(PaymentPlanActionTypes.ASYNC_PLAN, asyncPaymentPlan),
      yield takeEvery(PaymentPlanActionTypes.ASYNC_PAYMENT_METHOD, asyncGeneratePaymentMethod),
      yield takeEvery(PaymentPlanActionTypes.ASYNC_DISABLE_PLAN, asyncDisablePlan),
      yield takeLatest(PaymentPlanActionTypes.ASYNC_PAYMENT_PLANS_INSTALLMENT_DETAILS, asyncInstallmentDetails),
      yield takeLatest(PaymentPlanActionTypes.ASYNC_PIX_STATUS, asyncPix),
      yield debounce(500, PaymentPlanActionTypes.WEBHOOK_NOTIFICATIONS, asyncWebhooks),
      yield takeEvery(PaymentPlanActionTypes.WEBHOOK_NOTIFICATION_DETAILS, asyncWebhooktDetails),
      yield takeEvery(PaymentPlanActionTypes.ASYNC_SUMMARY, asyncSummary),
    ]);
  }
